import { render } from "./toTop.vue?vue&type=template&id=c18b4304&scoped=true"
import script from "./toTop.vue?vue&type=script&lang=js"
export * from "./toTop.vue?vue&type=script&lang=js"

import "./toTop.vue?vue&type=style&index=0&id=c18b4304&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__cosmic-mall-h5-entry/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c18b4304"]])

export default __exports__